import { useMemo, useState } from "react";
import { SxProps, Theme } from "@mui/material";
import { useAppSelector } from "src/app/hooks";
import { SelectOption } from "src/components/core-components/mui/ByzMuiMultiSelect";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import { useTranslate } from "src/locales";

interface ByzOfficesListProps {
  handleChange?: (val: any) => void;
  sx?: SxProps<Theme>;
  multiple?: boolean;
  value?: any;
  disableClearable?: boolean;
}

export default function ByzOfficesList({
  handleChange,
  sx,
  multiple = true,
  value,
  disableClearable,
}: ByzOfficesListProps) {
  const { t } = useTranslate();
  const authState = useAppSelector((state) => state.auth);

  const officeOptions: SelectOption[] = useMemo(
    () =>
      authState.user?.UserAssPriviliges?.map((item) => ({
        value: String(item.ID ?? 0),
        label: `${item.OFFICE_NAME}`,
      })) ?? [],
    [authState.user]
  );

  const handleSelectChange = (_event: any, newValue: any) => {
    handleChange?.(newValue);
  };

  return (
    <ByzMuiSelect
      label={t("office-list")}
      inputLabel={t("office-list")}
      options={officeOptions}
      value={value}
      onChange={handleSelectChange}
      multiple={multiple}
      sx={sx}
      disableClearable={disableClearable}
    />
  );
}

